import React from 'react';
import useStore from '../store/useStore';
import { useT } from '../i18n';

function IconAddAbove() {
  return (
    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="4" y="10" width="20" height="12" rx="1" />
      <line x1="4" y1="16" x2="24" y2="16" />
      <line x1="14" y1="2" x2="14" y2="8" />
      <line x1="11" y1="5" x2="17" y2="5" />
    </svg>
  );
}

function IconAddBelow() {
  return (
    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="4" y="2" width="20" height="12" rx="1" />
      <line x1="4" y1="8" x2="24" y2="8" />
      <line x1="14" y1="16" x2="14" y2="22" />
      <line x1="11" y1="19" x2="17" y2="19" />
    </svg>
  );
}

function IconDelete() {
  return (
    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" stroke="currentColor" strokeWidth="1.5">
      <rect x="4" y="4" width="16" height="16" rx="1" />
      <line x1="4" y1="12" x2="20" y2="12" />
      <line x1="22" y1="8" x2="27" y2="16" strokeWidth="2" />
      <line x1="27" y1="8" x2="22" y2="16" strokeWidth="2" />
    </svg>
  );
}

export default function Sidebar() {
  const t = useT();
  const readOnly = useStore((s) => s.readOnly);
  const selectedNodeId = useStore((s) => s.selectedNodeId);
  const selectedFieldIndex = useStore((s) => s.selectedFieldIndex);
  const nodes = useStore((s) => s.nodes);
  const addFieldAbove = useStore((s) => s.addFieldAbove);
  const addFieldBelow = useStore((s) => s.addFieldBelow);
  const deleteField = useStore((s) => s.deleteField);
  const deleteNode = useStore((s) => s.deleteNode);
  const setFieldCount = useStore((s) => s.setFieldCount);

  if (!selectedNodeId) return null;

  const node = nodes.find((n) => n.id === selectedNodeId);
  if (!node) return null;

  const fieldCount = node.data.fields.length;
  const isEntity = node.data.tableType === 'entity';
  const hasFieldSelected = selectedFieldIndex !== null;
  const canDeleteField =
    hasFieldSelected &&
    fieldCount > 1 &&
    !(isEntity && selectedFieldIndex === 0);

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h3>{node.data.name}</h3>
        <span className="sidebar-badge">{isEntity ? 'Table' : 'Enum'}</span>
      </div>

      <div className="sidebar-section">
        <div className="field-action-row">
          <span className="field-action-label">{t('sidebar.fields')}</span>
          {readOnly ? (
            <span className="field-count-input" style={{ textAlign: 'center' }}>{fieldCount}</span>
          ) : (
            <input
              className="field-count-input"
              type="number"
              min={isEntity ? 1 : 1}
              value={fieldCount}
              onChange={(e) => {
                const val = parseInt(e.target.value, 10);
                if (!isNaN(val)) setFieldCount(selectedNodeId, val);
              }}
            />
          )}
        </div>
      </div>

      {!readOnly && (
        <>
          <div className="sidebar-section">
            <div className="field-action-row">
              <span className="field-action-label">{t('sidebar.above')}</span>
              <button
                className="field-action-btn"
                onClick={() => hasFieldSelected && addFieldAbove(selectedNodeId, selectedFieldIndex)}
                disabled={!hasFieldSelected}
                title="Add field above"
              >
                <IconAddAbove />
              </button>
            </div>

            <div className="field-action-row">
              <span className="field-action-label">{t('sidebar.below')}</span>
              <button
                className="field-action-btn"
                onClick={() => hasFieldSelected && addFieldBelow(selectedNodeId, selectedFieldIndex)}
                disabled={!hasFieldSelected}
                title="Add field below"
              >
                <IconAddBelow />
              </button>
            </div>

            <div className="field-action-row">
              <span className="field-action-label">{t('sidebar.delete')}</span>
              <button
                className="field-action-btn delete"
                onClick={() => canDeleteField && deleteField(selectedNodeId, selectedFieldIndex)}
                disabled={!canDeleteField}
                title="Delete field"
              >
                <IconDelete />
              </button>
            </div>
          </div>

          <div className="sidebar-section">
            <button
              className="sidebar-delete-table"
              onClick={() => deleteNode(selectedNodeId)}
            >
              {t('sidebar.deleteTable')}
            </button>
          </div>
        </>
      )}

    </div>
  );
}
